import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
  Typography,
  IconButton,
  Alert,
  Divider
} from '@mui/material';
import { Copy, X, ShareNetwork } from '@phosphor-icons/react';

const PaymentLinkModal = ({ open, onClose, paymentLink, expiresAt, invoiceNumber }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(paymentLink);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (error) {}
  };

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: `Payment Link - Invoice ${invoiceNumber}`,
          text: `Please use this link to pay invoice ${invoiceNumber}`,
          url: paymentLink
        });
      } catch (error) {
        if (error.name !== 'AbortError') {}
      }
    } else {
      handleCopy();
    }
  };

  const formatExpiry = (date) => {
    if (!date) return 'Not specified';
    return new Date(date).toLocaleString('en-GB', {
      dateStyle: 'medium',
      timeStyle: 'short'
    });
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="h6">Payment Link</Typography>
          <IconButton onClick={onClose} size="small">
            <X size={20} />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Share this link with the client to allow them to pay the invoice securely via Stripe.
        </Typography>

        <TextField
          fullWidth
          value={paymentLink}
          InputProps={{
            readOnly: true
          }}
          sx={{ mb: 2 }}
        />

        <Box sx={{ display: 'flex', gap: 1, mb: 2 }}>
          <Button
            variant="outlined"
            startIcon={<Copy size={18} />}
            onClick={handleCopy}
            fullWidth
          >
            {copied ? 'Copied!' : 'Copy Link'}
          </Button>
          <Button
            variant="outlined"
            startIcon={<ShareNetwork size={18} />}
            onClick={handleShare}
            fullWidth
          >
            Share
          </Button>
        </Box>

        <Divider sx={{ my: 2 }} />

        <Box sx={{ mb: 2 }}>
          <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.5 }}>
            Link Expires:
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {formatExpiry(expiresAt)}
          </Typography>
        </Box>

        <Alert severity="info" sx={{ mt: 2 }}>
          <Typography variant="body2">
            The client will pay via Stripe. You'll receive the payment minus Stripe fees (2.9% + 30p) and platform fee (£3.00).
          </Typography>
        </Alert>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default PaymentLinkModal;
